import { render, staticRenderFns } from "./GenericViewer.vue?vue&type=template&id=5c2231b1&scoped=true&"
import script from "./GenericViewer.vue?vue&type=script&lang=js&"
export * from "./GenericViewer.vue?vue&type=script&lang=js&"
import style0 from "./GenericViewer.vue?vue&type=style&index=0&id=5c2231b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2231b1",
  null
  
)

export default component.exports